import { createReducer } from 'actionware';
import { createState } from 'stateware';
import {
  forgotPassword,
  resetPassword,
  showLogin,
  timeLeftTick,
  authLogin,
  authLogout
} from './loginActions';

const initialState = createState({
  resendCountdown: null,
  showingForgotPassword: false,
  showingResendCountdown: false
});

export default createReducer(initialState)
  .on(resetPassword, (state, action) => {
    return initialState.copy({
      resendCountdown: 60,
      showingForgotPassword: false,
      showingResendCountdown: true,
      data: action.data,
      email: action.recoverEmail
    })
  }
  )
  .on(authLogin, (state, user) =>
    state.copy({
      user
    })
  )
  .on(authLogout, (state) =>
    initialState
  )
  .on(showLogin, state =>
    state.copy({
      showingForgotPassword: false,
      showingResendCountdown: false
    })
  )
  .on(forgotPassword, state =>
    state.copy({
      showingForgotPassword: true,
      showingResendCountdown: false
    })
  )
  .on(timeLeftTick, (state, resendCountdown) =>
    state.copy({
      resendCountdown
    })
  )
